import {Component, Input} from '@angular/core';
import {Router} from '@angular/router';
import {MatSnackBar} from "@angular/material/snack-bar";

@Component({
  selector: 'app-detail',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.scss']
})
export class DetailComponent {
  @Input() header?: string;
  @Input() value?: string;
  @Input() link?: Array<any>;
  @Input() externalLink?: string;
  @Input() limitedAccess = false;
  @Input() active = true;
  @Input() pln = false;
  @Input() loading = false;
  constructor(
    private router: Router,
    private snack: MatSnackBar,
  ) {
  }

  click(targetBlank = false): void {
    if (this.link) {
      if (targetBlank) {
        const link = document.createElement('a');
        link.href = this.router.createUrlTree(this.link).toString();
        link.target = '_blank';
        link.click();
      } else {
        this.router.navigate(this.link);
      }
    }

    if (this.externalLink) {
      const link = document.createElement('a');
      link.href = this.externalLink;
      link.target = '_blank';
      link.click();
    }
  }

  copyMessage(val: string): void{
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.snack.open('Skopiowano do schowka: ' + val , '', {duration: 2000});

  }
}
